/**
 * Winners Page Sections
 * 
 * Registers all section components for the Winners page with the section registry.
 * Each section is auto-registered at module load time so they're available to the
 * section dispatcher in WinnersPage.
 */

import { registerSectionComponent } from '../../../config/sectionRegistry';
import WinnersHeroSection from './WinnersHeroSection';
import WinnersStatsBarSection from './WinnersStatsBarSection';
import WinnersFilterBarSection from './WinnersFilterBarSection';
import WinnersGridSection from './WinnersGridSection';
import WinnersSpotlightSection from './WinnersSpotlightSection';

// Register winners_hero
registerSectionComponent(
  'winners_hero',
  WinnersHeroSection,
  {
    category: 'hero',
    label: 'Winners Hero',
    description: 'Page title and subtitle for winners',
    supportedPages: ['winners'],
    defaultConfig: {},
  }
);

// Register winners_stats_bar
registerSectionComponent(
  'winners_stats_bar',
  WinnersStatsBarSection,
  {
    category: 'winners',
    label: 'Winners Stats Bar',
    description: 'Total winners, paid out, biggest win stats',
    supportedPages: ['winners'],
    defaultConfig: {},
  }
);

// Register winners_filter_bar
registerSectionComponent(
  'winners_filter_bar',
  WinnersFilterBarSection,
  {
    category: 'utility',
    label: 'Winners Filter Bar',
    description: 'Search, year filter, and view mode toggle',
    supportedPages: ['winners'],
    defaultConfig: {},
  }
);

// Register winners_grid
registerSectionComponent(
  'winners_grid',
  WinnersGridSection,
  {
    category: 'winners',
    label: 'Winners Grid',
    description: 'Main winners display (grid or list view)',
    supportedPages: ['winners'],
    defaultConfig: {},
  }
);

// Register winners_spotlight
registerSectionComponent(
  'winners_spotlight',
  WinnersSpotlightSection,
  {
    category: 'winners',
    label: 'Winners Spotlight',
    description: 'Featured winner callout card',
    supportedPages: ['winners'],
    defaultConfig: {},
  }
);

// Export all components for direct import if needed
export {
  WinnersHeroSection,
  WinnersStatsBarSection,
  WinnersFilterBarSection,
  WinnersGridSection,
  WinnersSpotlightSection,
};
